import { toQueryString } from "common/utils";

const mappedPivots = {
    currency_alias: "currency"
};

const getByPivot = function(subresource) {
    return function(pivot, params = {}) {
        // Normalize arguments to an array and convert mapped ones
        const pivots = (Array.isArray(pivot) ? pivot : [pivot]).map((p) => mappedPivots[p] || p);
        
        return `/merchant/:merchant_ref/${subresource}?${toQueryString({
            pivots,
            ...params
        }, false)}`;
    };
};

export const txn_search = {
    settlement: "/merchant/:merchant_ref/search/settlements/",
    chargeback: "/merchant/:merchant_ref/search/chargebacks/",
    authorizations: "/merchant/:merchant_ref/search/authorizations/",
    fees: "/merchant/:merchant_ref/search/fees/",
    fraud: "/merchant/:merchant_ref/search/fraud/",
    psd2: "/merchant/:merchant_ref/search/psd2/",
    get all_fraud() { return this.fraud; },
    get authorization() { return this.authorizations; },
    get chargebacks() { return this.chargeback; },
    get settlements() { return this.settlement; },
    get psd2_fraud() { return this.psd2; }
};

// Current v2 analytics
export const v2 = {
    fraud: {
        byPivot: getByPivot("fraud"),
        transactionsAll: "/merchant/:merchant_ref/processor/fraud_notices/transactions",
        byId: "/merchant/:merchant_ref/processor/fraud/transactions_all/:transaction_ref"
    },
    psd2: {
        byPivot: getByPivot("psd2"),
        transactionsAll: "/merchant/:merchant_ref/processor/psd2/transactions",
        byId: "/merchant/:merchant_ref/processor/settlements/transactions_all/:transaction_ref"
    },
    fraudsight: {
        byPivot: getByPivot("fraudsight"),
        transactionsAll: "/merchant/:merchant_ref/processor/fraudsight/transactions", // TODO MATT FRAUDSIGHT: What url endpoints?
        byId: "/merchant/:merchant_ref/processor/fraudsight/transactions_all/:transaction_ref"
    },
    threedsflex: {
        byPivot: getByPivot("threedsflex"),
        transactionsAll: "/merchant/:merchant_ref/processor/threedsflex/transactions",
        byId: "/merchant/:merchant_ref/processor/threedsflex/transactions_all/:transaction_ref"
    },
    authorizations: {
        byPivot: getByPivot("authorization"),
        retries: "/merchant/:merchant_ref/processor/authorizations/retries/",
        transactions: "/merchant/:merchant_ref/processor/authorization/transactions/",
        byId: "/merchant/:merchant_ref/processor/authorizations/transactions_all/:transaction_ref"
    },
    cashflow: {
        byPivot: getByPivot("cashflow")
    },
    settlements: {
        byPivot: getByPivot("settlement"),
        transactionsAll: "/merchant/:merchant_ref/processor/settlements/transactions_all/",
        byId: "/merchant/:merchant_ref/processor/settlements/transactions_all/:transaction_ref"
    },
    fees: {
        byPivot: getByPivot("fee"),
        taxes: "/merchant/:merchant_ref/processor/taxes/",
        transactions: "/merchant/:merchant_ref/processor/fees/transactions/",
        byId: "/merchant/:merchant_ref/processor/fees/transactions_all/:transaction_ref"
    },
    chargebacks: {
        byPivot: getByPivot("chargeback"),
        rateByNetwork: "/merchant/:merchant_ref/processor/chargebacks/rates/",
        transactions: "/merchant/:merchant_ref/processor/chargebacks/transactions/",
        byId: "/merchant/:merchant_ref/processor/chargebacks/transactions_all/:transaction_ref"
    },
    misc: {
        transactions: "/merchant/:merchant_ref/processor/misc/transactions/",
        transactionsDetail: (transType) => `/merchant/:merchant_ref/detail/${transType}`,
        byId: "/merchant/:merchant_ref/processor/misc/transactions_all/:transaction_ref"
    },
    get all_fraud() { return this.fraud; },
    get psd2_fraud() { return this.psd2; },
    reconciliation: "/merchant/:merchant_ref/processor/reconciliation/"
    // TODO:
    // params section, sort, order, start(utc date), end(utc date)
    // add txns by summary_ref
};

export const user = {
    merchants: "/user/merchants",
    notifications: "/merchant/:merchant_ref/user/notification/",
    exportData: "/merchant/:merchant_ref/user/export",
    
    reports: "/merchant/:merchant_ref/user/reports",
    auths_config: "/merchant/:merchant_ref/user/reports/authorizations",
    declines_config: "/merchant/:merchant_ref/user/reports/declines",
    chargebacks_config: "/merchant/:merchant_ref/user/reports/chargebacks",
    settlements_config: "/merchant/:merchant_ref/user/reports/settlements",
    cashflow_config: "/merchant/:merchant_ref/user/reports/cashflow",
    fees_config: "/merchant/:merchant_ref/user/reports/fees",
    
    exportStatuses: "/merchant/:merchant_ref/user/export/statuses/",
    exportStatusesAdmin: "/admin/reports/export/statuses/",
    exchangeToken: (downloadID) => `/merchant/:merchant_ref/user/export/token/${downloadID}`,
    optIns: "/merchant/:merchant_ref/user/opt_ins"
};

export const benchmarks = {
    merchant_count: "/merchant/:merchant_ref/benchmarks/merchant_count"
};

export const alerts = {
    alertDefinitions: "/merchant/:merchant_ref/alerts"
};

export const authentication = {
    sendActivationEmail: "/user/email/newUser/",
    login: "/user/login/",
    logout: "/user/logout",
    activate: "/user/activate",
    deactivate: "/user/deactivate",
    unlock: "/user/unlock",
    password: {
        reset: "/user/reset/",
        update: "/user/password/",
        validate: "/user/password/validate/"
    }
};

export const users = {
    all: "/users",
    byId: (id) => `/users/${id}`,
    me: "/users/me",
    login_history: (id) => `/users/${id}/login_history`
};

export const merchant = {
    settings: "/merchant/:merchant_ref/configuration/settings/",
    getPivots(pivotsName) {
        return `/merchant/:merchant_ref/processor/${pivotsName}/`;
    },
    admins: "/merchant/:merchant_ref/admins",
    users: "/merchant/:merchant_ref/users",
    groups: "/merchant/:merchant_ref/groups",
    permissions: "/merchant/:merchant_ref/permissions",
    user_permissions: "/merchant/:merchant_ref/user/permissions"
};

export const admin = {
    requests: "/admin/requests",
    requests_details: "/admin/requests/details"
};

export const dataAvailability = {
    status: "/merchant/:merchant_ref/availability",
    all_reports: "/merchant/:merchant_ref/all_reports"
};

export const buManager = {
    hierarchy: "/merchant/:merchant_ref/bu_hierarchy"
};

export const tracking = "/tracking";
